import React, { useEffect, useState, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import useApi from "../utils/useApi";


const formatDate = (dateString) => {
    if (!dateString || dateString === '') return '';
    
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
        // Return the original string if you want to see what's coming
        return dateString;
    }
    
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
};

const columns = [

    { field: "SystemKey", headerName: "System Key", flex: 1 },
    { field: "machineGuid", headerName: "Device Guid", flex: 1 },
    { field: "createdon", headerName: "created on", flex: 1 ,renderCell: (params) => formatDate(params.row.createdon) },
    { field: "comments", headerName: "comments", flex: 1 },
    { field: "comments_createdby", headerName: "comments created by", flex: 1 },
    { field: "comments_on", headerName: "comments created on", flex: 1 ,renderCell: (params) => formatDate(params.row.comments_on)},
    { field: "status", headerName: "Status", flex: 1 },
];

export default function DeviceDetails(props) {

    const [currentSelectedRow, setCurrentSelectedRow] = useState(null)
    const [showEditBox, setShowEditBox] = useState(false)
    const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
    const [selectedRowsData, setSelectedRowsData] = React.useState([]);

    const { data, error, loading, get } = useApi()
    const { data: companyDetailsData, error: companyDetailsError, loading: companyDetailsLoading, get: getCompanydetails } = useApi()
    const { data: postUpdateData, error: postUpdateError, loading: postUpdateLoading, post: postUpdate } = useApi()

    const [rows, setRows] = useState([])

    // useEffect(()=>{

    //     console.log("rowSelectionModel ", rowSelectionModel)
    // },[rowSelectionModel])


    React.useEffect(() => {
        // Map selected IDs to full row data whenever selectionModel changes
        const newSelectedRowsData = rows.filter(row => rowSelectionModel.includes(row.id));
        setSelectedRowsData(newSelectedRowsData);
        console.log('Selected Rows Data:', newSelectedRowsData);
    }, [rowSelectionModel]);


    useEffect(() => {

        if (data) {
            setRows(data)
        }

    }, [data])

  

    

    
    let company_code_from_local_storage = localStorage.getItem("masterCompanyCode")

    let company_details  = {COMPID:company_code_from_local_storage}

    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("");


    const getDeviceList = () => {
        get(`https://cubixweberp.com:213/api/CpaysCount/CUBOT/LICENSELIST/${company_details.COMPID}/-`);
    }

    const callCompanyDetails = () => {
        getCompanydetails(`https://cubixweberp.com:301/api/clientmanager/${company_details.COMPID}`)
    }

    useEffect(() => {
        getDeviceList()
        callCompanyDetails()
    }, []);


    useEffect(() => {

        console.log(" postUpdateData ", postUpdateData)

        if (postUpdateData?.result?.trim()?.toUpperCase() === "GENERATED") {
            alert("Successfully Updated ")
            getDeviceList()
            setCurrentSelectedRow(null)
            setShowEditBox(false)
        }


    }, [postUpdateData])

  



    const filteredRows = useMemo(() => {
        return rows.filter((row) => {
            const matchesSearch =
                searchText === "" ||
                Object.values(row).some((val) =>
                    String(val).toLowerCase().includes(searchText.toLowerCase())
                );

            const matchesStatus =
                statusFilter === "" || row.status === statusFilter;

            return matchesSearch && matchesStatus;
        });
    }, [rows, searchText, statusFilter]);

    const resetFilters = () => {
        setSearchText("");
        setStatusFilter("");
    };

    const handleChange = (e)=>{

        setCurrentSelectedRow({...currentSelectedRow, comments:e.target.value})
    }



    const updateChanges = ()=>{

        const currentUserName = localStorage.getItem("currentUserName");
        const arrayToSend = [
            {
                CMPCODE: "CUBOT",
                COMPID: company_details.COMPID,
                LICENSE: currentSelectedRow.machineGuid,
                COMMENTS: currentSelectedRow.comments,
                COMMENTS_CREATEDBY: currentUserName
            }
        ]

        let serialized = JSON.stringify(arrayToSend)

        console.log("edited array to pass", arrayToSend)

        postUpdate(`https://cubixweberp.com:213/api/CRMLicenseUpdate`, serialized, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        
    }

    const handleRowClick = (params) => {
        console.log("Row clicked:", params.row);

        setCurrentSelectedRow(params.row)
        setShowEditBox(true)

    };

    const onRowsSelectionHandler = (ids) => {
        // const selectedRowsData = ids.map((id) => rows.find((row) => row.id === id));
        console.log(ids);
    };

    


    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        }

        const debouncedHandleResize = debounce(handleResize, 500);

        window.addEventListener('resize', debouncedHandleResize);

        return () => {
            window.removeEventListener('resize', debouncedHandleResize);
        };
    }, []);

    // Debounce function
    const debounce = (func, delay) => {
        let timer;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, arguments);
            }, delay);
        };
    }



    return (
        <div className="pb-8">

            <div className="flex justify-between items-center">

              

            <h1 className="text-xl font-bold text-slate-800">
                Device Details
            </h1>


            </div>

            <>

                {error && <p className="text-red-600 mb-2">{error}</p>}


                <div className="flex justify-between items-center my-4">
                {/* Row count */}
                <p className="ms-4 text-sm text-gray-600 mb-2">
                    Showing {filteredRows.length} result{filteredRows.length !== 1 ? "s" : ""}
                </p>

                {/* Filters */}
                <div className="pe-4 flex justify-end gap-4 ">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="px-4 py-2 border border-gray-300 rounded w-full md:w-1/3 focus:outline-none focus:ring focus:border-blue-400"
                    />
{/* confimation needed what to give on this list thats why commented */}
                    {/* <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        className="px-4 py-2 border border-gray-300 rounded w-full md:w-1/4 focus:outline-none"
                    >
                        <option value="">All Statuses</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select> */}

                    <button
                        onClick={resetFilters}
                        className="bg-gray-100 text-gray-800 px-4 py-2 rounded hover:bg-gray-200"
                    >
                        Reset
                    </button>
                </div>
                </div>

                {
                    showEditBox &&
                    <div className="m-4 shadow bg-white p-4">
                        <p>{currentSelectedRow?.SystemKey}</p>
                        <input className="px-4 py-2 border border-gray-300 rounded w-full md:w-1/3 focus:outline-none focus:ring focus:border-blue-400" placeholder="comments" value={currentSelectedRow?.comments} onChange={(e)=>handleChange(e)}/>
                        <button class="px-4 py-2 ms-2 bg-blue-600 text-white rounded hover:bg-blue-700" onClick={()=>updateChanges()}>Save</button>
                    </div>
                }
                {/* Table */}
                <DataGrid
                    getRowId={(row) => row.SystemKey}
                    rows={filteredRows}
                    columns={columns}
                    pageSize={5}
                    loading={loading}
                    rowsPerPageOptions={[5]}
                    disableRowSelectionOnClick


                    onRowClick={handleRowClick}
                    className="bg-white"
                    sx={{
                        height: "400px",
                        border: "none",
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "#f3f4f6", // Tailwind gray-100
                            fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#f9fafb", // Tailwind gray-50
                        },
                    }}
                />
            </>


        </div>
    );
}
